import './LoadingPage.css';
import Logo from './Logo';

export default function LoadingPage() {
  return (
    <div className="loading-page">
      <div className="loading-content">
        <div className="loading-logo">
          <Logo size={64} />
          <span className="loading-title">SCRAWL</span>
        </div>
        
        <div className="loading-bar-container">
          <div className="loading-bar">
            <div className="loading-bar-fill"></div>
          </div>
        </div>
      </div>
      
      <div className="loading-footer">
        <span>LOADING RESOURCES</span>
      </div>
    </div>
  );
}
